import { render, staticRenderFns } from "./generic_container.vue?vue&type=template&id=e5e4b308&scoped=true&"
import script from "./generic_container.vue?vue&type=script&lang=js&"
export * from "./generic_container.vue?vue&type=script&lang=js&"
import style0 from "./generic_container.vue?vue&type=style&index=0&id=e5e4b308&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e4b308",
  null
  
)

export default component.exports